import { useCallback, useState } from "react";

export const useTableData = (api) => {
    const [loadingData, setLoadingData] = useState(true);
    const [errorData, setErrorData] = useState(null);

    const [tableData, setTableData] = useState([]);
    const [tableMeta, setTableMeta] = useState({});
    const [tableLinks, setTableLinks] = useState({});

    const fetchData = useCallback(
        async (params = {}) => {
            try {
                setLoadingData(true);
                const response = await api(params);

                setTableData(response.data);
                setTableLinks(response.links);
                setTableMeta(response.meta);
            } catch (error) {
                setErrorData(error);
            } finally {
                setLoadingData(false);
            }
        },
        [api]
    );

    return {
        loadingData,
        errorData,
        tableData,
        tableMeta,
        tableLinks,
        fetchData,
    };
};
